export default "__VITE_ASSET__BUO2M1QT__"